import styled from 'styled-components';

export const Container = styled.div`
display: flex;
align-items: center;
justify-content: center;
flex-direction: column;
padding: 2rem;
.input-id{
    font-size: 14px !important;
    font-family: 'Roboto',sans-serif;
    font-weight: 500;
    background-color: #e1f4ff8c !important;
    border: none !important;
    margin: 20px 0px;
    outline:none !important;
    padding: 10px 20px;
    width:100%;
}
`;

export const ModalButton = styled.button`
border: none;
outline: none;
border-radius: 5px;
width: 125px;
height: 32px;
font-size: 14px;
font-weight: 600;
background-image: linear-gradient(to right,#41d4b3,#067D68);
color: white;
margin-top: 25px;
box-shadow: rgb(136 165 191 / 48%) 6px 2px 16px 0px, rgb(255 255 255 / 80%) -6px -2px 16px 0px;
&:hover{
transform: translateY(-3px);
box-shadow: 0 4px 17px rgb(0 0 0 / 35%);
}
`;